import { expect, is, test } from "@benchristel/taste"
import { render } from "preact"
import { useLayoutEffect, useState } from "preact/hooks"
import type { Path } from "./Path"
import { uiTest } from "./testUtilities"

export type NavigateTo = (path: Path) => unknown

export function useURLHash(wndw: HasLocationHash): [string, NavigateTo] {
  const [hash, setHash] = useState(wndw.location.hash)

  useLayoutEffect(() => {
    const handleHashChange = () => setHash(wndw.location.hash)
    wndw.addEventListener("hashchange", handleHashChange)
    return () => wndw.removeEventListener("hashchange", handleHashChange)
  }, [wndw])

  return [
    hash.match("#") ? hash.slice(1) : hash,
    (v: string) => {
      wndw.location.hash = v
    },
  ]
}

export type HasLocationHash = {
  location: { hash: string }
  addEventListener: (eventName: string, handler: () => unknown) => void
  removeEventListener: (eventName: string, handler: () => unknown) => void
}

test("useURLHash", {
  "cleans hash of octothorpe": uiTest((el) => {
    const fakeWindow: HasLocationHash = {
      location: { hash: "#blue" },
      addEventListener: () => {},
      removeEventListener: () => {},
    }

    let hash: string | void = undefined
    function TestHarness() {
      ;[hash] = useURLHash(fakeWindow)
      return <></>
    }

    render(<TestHarness />, el)
    expect(hash, is, "blue")
  }),
})
